/**
 * "Somebody forgot their password", for the people who can set a new one.
 * The request itself comes from the sign-in screen (ForgotPassword.tsx).
 */
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { api } from '../api.js';
import { useAuth } from '../state/auth.js';
import { useT } from '../i18n/index.js';

export function StaffAlert() {
  const t = useT();
  const { can, user } = useAuth();
  const { pathname } = useLocation();
  const [n, setN] = useState(0);
  const allowed = !!user && can('users.edit');

  useEffect(() => {
    if (!allowed) return;
    let alive = true;
    const load = () =>
      api<unknown[]>('/admin/password-requests')
        .then((rows) => alive && setN(rows.length))
        .catch(() => undefined);
    void load();
    const timer = window.setInterval(load, 5 * 60_000);
    return () => {
      alive = false;
      clearInterval(timer);
    };
  }, [allowed, pathname]);

  // On the Staff screen the requests are already in front of them.
  if (!allowed || n === 0 || pathname === '/users') return null;
  return (
    <div className="note-info till-alert" role="status">
      <span>{t('forgot.alert', { n })}</span>
      <Link to="/users">{t('forgot.alertLink')}</Link>
    </div>
  );
}
